import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility.js";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff.js";
import { useState} from "react";
import {useEvents} from "../DanceEventProvider.jsx";
import AutorenewIcon from "@mui/icons-material/Autorenew.js";
import { useAuth } from "../Auth/AuthPage.jsx";
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';


const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];
const token = window.localStorage.getItem("authToken");

export const VisibilityButton = (props) => {

    const [loading, setLoading] = useState(false)
    const {documentId, listing} = props.slot
    const {loadEvents} = useEvents()
    const type = props.slot.hasOwnProperty('artist') ? 'event-artists' : 'event-instructors';
    const {user} = useAuth()

    if (!user || !user.calendarAdmin) return <span />;

    let nextListing;
    switch (listing) {
        case 'hidden':
        case 'pending':
        case 'deleted':
            nextListing = 'active';
            break;
        case 'active':
        default:
            nextListing = 'deleted';
            break;
    }

    const handleEventSlotStatusUpdate = () => {
       setLoading(true)
        fetch(BACKEND_HOST + `/${type}/` + documentId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                data: {
                    listing: nextListing
                }
            })
        }).then(() => {
            loadEvents()
            setLoading(false)
        })
    }


    const loadingIcon = <AutorenewIcon sx={{
            animation: "spin 2s linear infinite",
            "@keyframes spin": {
                "0%": {
                    transform: "rotate(0deg)",
                },
                "100%": {
                    transform: "rotate(360deg)",
                },
            },
        }} />

    if (loading) {
        return <IconButton style={{padding: "0px 0px 0px 5px"}} size="small" disabled>
            {loadingIcon}
        </IconButton>
    }

    let color, icon, newStatus
    switch (listing) {
        case "active":
            color = "success";
            icon = <VisibilityIcon/>
            newStatus = "deleted"
            break;

        case "hidden":
            color = "error";
            icon = <VisibilityOffIcon/>
            newStatus = "approved"
            break;   

        case "pending":
            color = "warning";
            icon = <VisibilityIcon/>
            newStatus = "approved"
            break;

        case "deleted":
        default:
            color = "error";
            icon = <RestoreFromTrashIcon/>
            newStatus = "approved"
            break;

    }

    return <IconButton style={{padding: "0px 0px 0px 5px"}} size="small" color={color} onClick={() => {
            handleEventSlotStatusUpdate(documentId)
        }}>
        {icon}
    </IconButton>
}

export default VisibilityButton